import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import LandingPage from './pages/LandingPage'
import SetupGuide from './pages/SetupGuide'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import NotFound from './pages/NotFound'

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-primary-900 noise-bg">
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/setup" element={<SetupGuide />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </div>
    </ErrorBoundary>
  )
}

export default App
